var exports = {
  "l": "loadMoreWrapper__XvOhNc",
};

module.exports = exports;
